<template>
  <div class="page-contract-search mwclg-style">
    <div class="order-search" >
      <div class="flex">
        <el-form ref="searchForm" :model="searchForm" style="flex: 1" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.OrderNumber') ">
                <el-input v-model="searchForm.ownerOrderNo" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.MaterialNumber') ">
                <el-input v-model="searchForm.ownerCargoCodeContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.EnglishName') ">
                <el-input v-model="searchForm.cargoNameEnContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.BatchNumber') ">
                <el-input v-model="searchForm.batchNoContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.MaterialName') ">
                <el-input v-model="searchForm.cargoNameCnContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="UB">
                <el-input v-model="searchForm.ubContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.Standards') ">
                <el-input v-model="searchForm.specificationContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.InDateFrom') ">
                <!-- <el-date-picker size="small" v-model="searchForm.inDateFrom" type="date" value-format="yyyy-MM-dd"
                  :placeholder="$t('DomesticWarehousing.SelectDate') ">
                </el-date-picker> -->
                <el-date-picker v-model="CreateInterval" type="daterange" range-separator="~" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" size="small" class="custom-input" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.InDateTo') ">
                <el-date-picker size="small" v-model="searchForm.inDateTo" type="date" value-format="yyyy-MM-dd"
                  :placeholder="$t('DomesticWarehousing.SelectDate') ">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.Warehouse')">
                <el-select size="small" v-model="whName" filterable remote
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') " :remote-method="remoteMethod"
                  :loading="loading">
                   remote-method封装好的钩子函数。当用户在输入框中输入内容的时候，会触发这个函数的执行，
      把输入框对应的值作为参数带给回调函数，loading的意思就是远程搜索的时候等待的时间，即：加载中
                  <el-option v-for="item in options" :key="item.whID" :label="item.whName" :value="item.whName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
        <div style="margin-top: 10px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="search">{{
            $t('DomesticWarehousing.Query') }}</el-button>
          <el-button size="small" icon="el-icon-refresh-right" @click="reset">{{
            $t('DomesticWarehousing.Reset') }}</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportExcel">{{
            $t('DomesticWarehousing.Export') }}</el-button>
        </div>
      </div>
    </div>
    <div class="order-list">
      <p class="title">
        {{ $t('DomesticWarehousing.StockList') }}
      </p>
      <div>
        <el-table v-loading="loading" :data="dataList" stripe show-summary :summary-method="getSummaries">
          <el-table-column prop="ownerOrderNo" min-width="180" :label="$t('DomesticWarehousing.InboundOrder')">
          </el-table-column>
          <el-table-column prop="inDate" min-width="180" :label="$t('DomesticWarehousing.InboundTime')">
          </el-table-column>
          <el-table-column prop="ownerCargoCode" min-width="180" :label="$t('DomesticWarehousing.MaterialNumber')">
          </el-table-column>
          <!-- <el-table-column prop="mnemonicsCode" min-width="130" :label="$t('DomesticWarehousing.MnemonicCode')">
          </el-table-column> -->
          <el-table-column min-width="240" prop="cargoNameCn" :label="$t('DomesticWarehousing.ChineseName')">
          </el-table-column>

          <el-table-column min-width="240" prop="cargoNameEn" :label="$t('DomesticWarehousing.EnglishName')">
          </el-table-column>

          <el-table-column min-width="120" prop="specification" :label="$t('DomesticWarehousing.Standards')">
          </el-table-column>
          <el-table-column min-width="110" prop="controlType" :label="$t('DomesticWarehousing.ControlType')">
          </el-table-column>
          <el-table-column min-width="140" prop="batchNo" :label="$t('DomesticWarehousing.BatchNumber')">
          </el-table-column>
          <el-table-column min-width="120" prop="uB" label="UB">
          </el-table-column>
          <!-- <el-table-column min-width="120" prop="sBU" label="SBU">
          </el-table-column> -->
          <el-table-column min-width="140" prop="qty" :label="$t('DomesticWarehousing.StockQty')">
          </el-table-column>
          <el-table-column min-width="140" prop="inPickingQty" :label="$t('DomesticWarehousing.InPickingQty')">
          </el-table-column>
          <el-table-column min-width="140" prop="availableQty" :label="$t('DomesticWarehousing.AvailableQty')">
          </el-table-column>
          <el-table-column min-width="120" prop="packUnitCode" :label="$t('DomesticWarehousing.PackagingUnit')">
          </el-table-column>
          <el-table-column min-width="120" prop="baseQty" :label="$t('DomesticWarehousing.BasicQty')">
          </el-table-column>
          <el-table-column min-width="100" prop="baseUnitCode" :label="$t('DomesticWarehousing.BasicUnit')">
          </el-table-column>
          <el-table-column min-width="110" prop="grossWeightText" :label="$t('DomesticWarehousing.GrossWeight')">
          </el-table-column>
          <el-table-column min-width="180" prop="invalidDate" :label="$t('DomesticWarehousing.ExpirationDate')">
          </el-table-column>
          <el-table-column min-width="100" prop="validUseDaysText" :label="$t('DomesticWarehousing.ShelfLife')">
          </el-table-column>
          <!-- <el-table-column min-width="140" prop="whName" :label="$t('DomesticWarehousing.WarehouseName')">
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div class="pagination-info">
      <div style="color:#999;font-size: 12px;margin-left: 220px;"></div>
      <el-pagination background align="left" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchForm.pageNo" :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100, 1000, 2000]" layout="total, sizes, prev, pager, next, jumper"
        :total="dataCount" />
    </div>
  </div>
</template>
<script>
import BarChart from '@/components/wms/barChart';
import { getSearchInventoryDataApi, api, getWarehouseDataApi } from '@/api/wms';
import {
  parseTime,
  dateAdds
} from '@/utils/index'
import i18n from '@/i18n/i18n'
export default {
  components: {
    BarChart,
  },
  props: {
    jobType: {
      type: String,
      default: 'DC',
    },
    customerCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchForm: {
        ownerOrderNo: '',
        poNoContains: '',
        ownerCargoCodeContains: '',
        batchNoContains: '',
        cargoNameCnContains: '',
        cargoNameEnContains: '',
        ubContains: '',
        specificationContains: '',
        inDateFrom: '',
        inDateTo: '',
        whName: '',
        Lang: '',
        customerCode: this.customerCode,
        pageNo: 1,
        pageSize: 10,
      },
      whName: '',
      loading: false,
      dataCount: 0,
      dataList: [],
      CreateInterval: [
        parseTime(dateAdds(new Date(), -15, 'd'), '{y}-{m}-{d}'),
        parseTime(new Date(), '{y}-{m}-{d}')
      ], 
      wareHouseList: [],
      options: [],
    };
  },
  computed: {},
  mounted() {
    this.search();
    //this.GetWareHouseData();
  },
  methods: {
    async search() {
      this.loading = true;
      this.searchForm.inDateFrom = this.CreateInterval[0];
      this.searchForm.inDateTo = this.CreateInterval[1];
      const lang = this.$ls.get('lang');
      const params = this.searchForm
      params.whName = this.whName
      params.Lang = lang;
      if (this.searchForm.inDateFrom == '' || this.searchForm.inDateFrom == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.StartTimeEm'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      if (this.searchForm.inDateTo == '' || this.searchForm.inDateTo == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.EndTimeEn'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var startdate = new Date(this.searchForm.inDateFrom);
      var enddate = new Date(this.searchForm.inDateTo);
      var startMonth = new Date(startdate.setMonth(startdate.getMonth() + 1));
      if (enddate > startMonth) {
        this.$message({
          message: i18n.t('DomesticWarehousing.DateMonthCanNot'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var res = await getSearchInventoryDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.dataList = data.items
        this.dataCount = data.count
      } else {
        this.messagebox.alert('查询失败')
      }
      this.loading = false;
    },
    exportExcel() {
      this.searchForm.inDateFrom = this.CreateInterval[0];
      this.searchForm.inDateTo = this.CreateInterval[1];
      if (this.searchForm.inDateFrom == '' || this.searchForm.inDateFrom == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.StartTimeEm'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      if (this.searchForm.inDateTo == '' || this.searchForm.inDateTo == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.EndTimeEn'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      const lang = this.$ls.get('lang');
      this.searchForm.Lang = lang;
      var startdate = new Date(this.searchForm.inDateFrom);
      var enddate = new Date(this.searchForm.inDateTo);
      var startMonth = new Date(startdate.setMonth(startdate.getMonth() + 1));
      if (enddate > startMonth) {
        this.$message({
          message: i18n.t('DomesticWarehousing.DateMonthCanNot'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var queryString = Object.keys(this.searchForm).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(this.searchForm[key])
      }).join('&')
      const url = api.exportSearchInventoryDataApiUrl + '?' + queryString
      window.location.href = url
    },
    async GetWareHouseData() {
      const params = { Lang: '' };
      params.Lang = this.$ls.get('lang');
      var result = await getWarehouseDataApi(params)
      this.wareHouseList = result.data;
    },
    remoteMethod(query) {
      // 如果用户输入内容了，就发请求拿数据，远程搜索模糊查询
      if (query !== '') {
        this.loading = true; // 开始拿数据喽
        // 这里模拟发请求，res就当成发请求返回来的数据吧。
        this.loading = false // 拿到数据喽
        // 然后把拿到的所有数据，首先进行一个过滤，把有关联的过滤成一个新数组给到options使用
        this.options = this.wareHouseList.filter((item) => {

          // indexOf等于0代表只要首个字匹配的，如：搜索 王  王小虎数据会被过滤出来，但是 小虎王的数据不会被过滤出来。因为indexOf等于0代表以什么开头
          // return item.label.toLowerCase().indexOf(query.toLowerCase()) == 0

          // indexOf大于-1代表的是，只要有这个字出现的即可，如：搜索 王 王小虎、小虎王、小王虎都会被过滤出来。因为indexOf找不到才会返回-1，
          // 大于-1说明只要有就行，不论是不是开头也好，中间也好，或者结尾也好
          return item.whName.toLowerCase().indexOf(query.toLowerCase()) > -1
        })
      } else {
        this.options = [];
      }
    },
    getCurrentTime() {
      var date = new Date()
      date.setDate(1)
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      this.searchForm.inDateFrom = date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthStart() {
      var date = new Date()
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()

      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      this.searchForm.inDateTo = date.getFullYear() + '-' + month + '-' + day
    },
    reset() {
      this.whName = ''
      this.searchForm = {
        ownerOrderNoContains: '',
        poNoContains: '',
        ownerCargoCodeContains: '',
        batchNoContains: '',
        cargoNameCnContains: '',
        cargoNameEnContains: '',
        ubContains: '',
        specificationContains: '',
        startDate: '',
        endDate: '',
        customerCode: this.customerCode,
        pageNo: 1,
        pageSize: this.searchForm.pageSize,
      };
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageNo = 1;
      this.searchForm.pageSize = val;
      this.search();
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val;
      this.search();
    },
    async getInOutTicketStatistics() {
      this.inOutTicketLoading = true;
      const params = {
        Duration: this.timeDimension,
        CustomerCode: this.customerCode,
      };
      console.log('params', params);
      var res = await getSearchInventoryDataApi(params);
      if (res && res.code == 200) {
        var data = res.data;
        this.inOutTicketData = data;
        console.log(this.inOutTicketData);
      } else {
        this.messagebox.alert('查询失败');
      }
      this.inOutTicketLoading = false;
    },
    // 合计和小计赋值
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // 保留换行符    选中合计行的每一个元素，然后给每一个元素都添加css样式whiteSpace。
      this.$nextTick(() => {
        const elements = document.querySelectorAll(
          '.el-table__footer-wrapper div.cell'
        );
        elements.forEach((element) => {
          // whiteSpace用于控制元素内部空白符（包括空格、换行符等）的处理方式。pre-wrap：表示浏览器会保留连续的空白符和换行符，且会自动换行。
          element.style.whiteSpace = 'pre-wrap';
        });
      });
      // 以下是对小计和总计分别进行赋值
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = i18n.t('DomesticWarehousing.Total');
          return;
        }
        // 将当前列的所有值存储到values中  注：非数字会返回NaN
        const values = data.map((item) => Number(item[column.property]));
        // 将要进行小计合计的字段组成一个数组
        const label = ['qty', 'inPickingQty', 'availableQty', 'grossWeight'];
        // 如果label包含当前column.property，则进行数据处理
        if (label.includes(column.property)) {
          // 小计
          const Subtotal = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              // 如果是数字则进行累加
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toFixed(2);
          // 总计
          sums[index] = Subtotal;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
};
</script>
<style scoped>
.order-search {
  margin-top: 10px;
  background: white;
  border-radius: 4px;
  padding: 10px 10px;
  height:auto !important;
}
.order-list {
  background: white;
  margin-top: 10px;
  border-radius: 4px;
  padding: 10px 10px;
}
.order-list .list-item {
  margin-bottom: 8px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: #040404;
  line-height: 22px;
  margin-bottom: 10px;
}
</style>
<style>
.el-select,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.tms-style .el-input__inner {
  max-width: none;
}
.el-loading-mask {
  z-index: 1000;
}
.pagination-info {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 36px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    z-index: 3;
  }
</style>
